import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const OperatorMcpConnections = lazy(() =>
  import("@scenes/OperatorMcpConnections").then((module) => ({
    default: module.OperatorMcpConnections,
  }))
);

export const operatorMcpConnectionsNRO: NavigationRoutingObject = {
  Component: OperatorMcpConnections,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "partner-integrations",
  heading: (t: I18nT<"dashboard-navigation">) => t("operator-mcp-connections-heading", "Operator MCP Connections"),
  description: (t: I18nT<"dashboard-navigation">) =>
    t("operator-mcp-connections-description", "MCP servers BrazeAI Operator can use tools from"),
  icon: "nav-system-technology-partners",
  pageNameForTracking: () => "Operator MCP Connections",
  // Same rule as the endpoints and useCanUseOperator: the useOperator permission applies only with its flipper on.
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) =>
    featureOn("sage_ai_agentic_mcp_connections") &&
    (!featureOn("fix_granular_permission_use_operator") ||
      hasPermission("appGroup", { permission: "useOperator" })),
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/integrations/operator_mcp_connections/:appGroupId",
};
